import { Router, RouterStateSnapshot } from '@angular/router';

export type GuardArea = 'admin' | 'partner';

export function redirectAccessDenied(router: Router, state: RouterStateSnapshot, area: GuardArea): false {
  router.navigate(['/access-denied'], {
    queryParams: {
      area,
      returnUrl: state.url,
    },
  });
  return false;
}
